import React from 'react'
import GenericError from './GenericError'
import LinkExpiredError from './LinkExpiredError'
import LinkUsedError from './LinkUsedError'
import styles from './Error.scss'

type Props = {
  body?: string
  code?: string
  ctaText?: string
  title?: string
}

export default function Error({
  body = "We've had a technical problem, please try again later.",
  code = 'callback.error',
  ctaText = 'Back to previous page',
  title = 'Sorry, something went wrong',
}: Props): JSX.Element {
  const isLinkExpiredError = code.includes('link_expired')
  const isLinkUsedError = code.includes('link_used')
  const isGenericError = !(isLinkExpiredError || isLinkUsedError)

  return (
    <div data-test="error" className={styles.container}>
      <div className={styles.header}>
        <h1 data-test="error-title" className={styles.headerText}>
          {title}
        </h1>
      </div>
      {isLinkExpiredError && <LinkExpiredError code={code} />}
      {isLinkUsedError && <LinkUsedError code={code} />}
      {isGenericError && <GenericError body={body} ctaText={ctaText} />}
    </div>
  )
}
